<script>
    let notice = "";

    async function getNotice() {
        const url = `https://www.1hg.org/programme_addition_default`;
        const response = await fetch(`https://api.allorigins.win/raw?url=${encodeURIComponent(`${url}?t=${new Date().getTime()}`)}`);
        const data = await response.text();
        return data;
    }
    getNotice().then( data => {
        notice = data;
    });

</script>
<div class="wrapper">
    <div class="notice">
        {@html notice}
    </div>
    <p class="clear">
        <span class="bold">Notice to Parents/Guardians</span><br/>
        Online Scout Manager is how we communicate by default. Please make sure to check
        your e-mail for details of nights and events where locations and times deviate
        from the standard. If you miss an email, or think you may have, check OSM, where
        you can see an archive of recent emails sent.
    </p>

    <p class="extra_notice">
    </p>

</div>

<style>
    div.socials {
        text-align: center;
        width: 600px;
        margin: auto;
        min-height: 200px;
    }
    div.notice {
        text-align: center;
        width: 600px;
        margin: 0 auto;
        background: #006ddf;
        color: #fff;
        border: 1px solid #003982;
        -webkit-print-color-adjust: exact;
    }
    .clear {
        clear: both;
    }
    div.socials > div {
        float: left;
    }
    .fa {
            padding: 20px;
            font-size: 130px;
            width: 140px;
            text-decoration: none;
            /* margin: 5px 80px; */
    }
    div.wrapper {
        width: 90%;
        margin: 0 auto;
        padding-top: 100px;
    }
    span.bold {
        font-weight: bold;
    }
    p.extra_notice {
        text-align: center;
        color: #33f;
    }
    td.right {
        padding-left: 40px;
    }
</style>